/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    sessionId: z.string(),
    primaryKey: z.string(),
    before: z.any(),
    after: z.any(),
    context: z.any(),
    database: z.string(),
    schema: z.string(),
    table: z.string(),
    operation: z.string(),
    committedAt: z.coerce.date().default(() => new Date()),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    sessionId: z.string(),
    primaryKey: z.string(),
    before: z.any(),
    after: z.any(),
    context: z.any(),
    database: z.string(),
    schema: z.string(),
    table: z.string(),
    operation: z.string(),
    committedAt: z.coerce.date(),
}
).strict();
const relationSchema = z.object({
    impersonatorUser: z.record(z.string(), z.unknown()),
    impersonatedUser: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    impersonator: z.string(),
    impersonated: z.string(),
}
);

/**
 * `ImpersonationLog` schema excluding foreign keys and relations.
 */
export const ImpersonationLogScalarSchema = baseSchema;


/**
 * `ImpersonationLog` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ImpersonationLogSchema = ImpersonationLogScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ImpersonationLogPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ImpersonationLogPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    sessionId: z.string(),
    primaryKey: z.string(),
    before: z.any(),
    after: z.any(),
    context: z.any(),
    database: z.string(),
    schema: z.string(),
    table: z.string(),
    operation: z.string(),
    committedAt: z.coerce.date()
}).partial().passthrough();


/**
 * `ImpersonationLog` schema for create operations excluding foreign keys and relations.
 */
export const ImpersonationLogCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, committedAt: true
});


/**
 * `ImpersonationLog` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ImpersonationLogCreateSchema = ImpersonationLogCreateScalarSchema.merge(fkSchema);


/**
 * `ImpersonationLog` schema for update operations excluding foreign keys and relations.
 */
export const ImpersonationLogUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `ImpersonationLog` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ImpersonationLogUpdateSchema = ImpersonationLogUpdateScalarSchema.merge(fkSchema.partial());

